import { axiosInstance } from "lib/axios"
import { searchAPI } from "services/apis.service"

export const getEbscoSearch = async (searchTerm, timePeriod, pageNumber, pageSize = 21) => {
    const { data } = await axiosInstance.post(searchAPI.ebscoSearch, {
      searchTerm: searchTerm,
      timePeriod: timePeriod,
      pageNumber: pageNumber,
      pageSize: pageSize,
    });

    return data.data;
}
